import React from 'react'
import clsx from 'clsx'
import { Person } from '@/components/molecules/Person/Person'
import { PersonComponentType, PersonType } from '@/components/molecules/Person/Person.types'
import { QuotesTypes } from './types'
import * as styles from './QuotesSection.module.css'

export function QuotesSection({ people }: QuotesTypes) {
  return (
    <section className="flex items-center flex-col max-w-screen-desktop mx-auto px-12 netbook:px-90 netbook:py-64">
      <ul className={clsx(styles.list, 'flex flex-1 flex-wrap flex-col tablet:flex-row justify-between')}>
        {people.map((person: PersonType) => (
          <li key={person._uid} className={styles.element}>
            <Person
              image={person.image}
              name={person.name}
              role={person.role}
              description={person.description}
              componentType={PersonComponentType.Quote}
            />
          </li>
        ))}
      </ul>
    </section>
  )
}
